<div>
  <p-panel header="Ordering Provider">
    <provider-search [providerLabel]="'Ordering Provider'" (search)="onSearch($event)"></provider-search>

    @if (searching) {
      <p-progressSpinner></p-progressSpinner>
    }

    @if (selectedProvider) {
      <ordering-provider-account
        [providerAccount]="selectedProvider"
        [isGoldCardProvider]="isGoldCardProvider"
        [isGoldCardVisible]="isGoldCardVisible"
        [goldCardAuthorizationType]="goldCardAuthorizationType"
        >
      </ordering-provider-account>
    }

    @if (searchResult?.length > 1) {
      <ordering-provider-select
        [providers]="searchResult"
        [product]="product"
        (selected)="selectProvider($event)"
      ></ordering-provider-select>
    }

    @if (searchResult && !searchResult.length || newProviderDefaultData) {
      <new-provider
        panelHeader="Enter new Ordering Provider information"
        acknowledgementText="Ordering Provider not found"
        [defaultData]="newProviderDefaultData"
        (provider)="setNewProvider($event)"
        >
        <div class="mb-4">
          <p class="font-semibold" data-test-id="npi-not-found-message">
            NPI was not found. To continue, please select the checkbox below and add the new Provider information.
          </p>
        </div>
      </new-provider>
    }
  </p-panel>

  <div class="flex justify-between pt-6">
    <div>
      <button
        pButton
        severity="danger"
        aria-label="Cancel Create Authorization"
        label="Cancel"
        icon="pi pi-times"
        type="button"
        data-test-id="cancel-request-button"
        (click)="onCancel()"
      ></button>
    </div>

    <div>
      <button
        pButton
        aria-label="Back Step to Servicing Facility"
        label="Back"
        icon="pi pi-arrow-left"
        class="p-button-secondary mr-2"
        type="button"
        data-test-id="back-step-button"
        (click)="onClickBack()"
      ></button>
      <button
        pButton
        aria-label="Next Step to ClinicalInformation"
        label="Next"
        icon="pi pi-arrow-right"
        iconPos="right"
        type="button"
        data-test-id="next-step-button"
        [disabled]="!submitData"
        (click)="onSubmit()"
      ></button>
    </div>
  </div>
</div>
